
import {serializable, alias, object, list, primitive} from 'serializr';

export class StudentActivitiesModel { 

	@serializable(alias('signUps', primitive()))
	totalSignups?: number;

	@serializable(alias('activeUsers', primitive()))
	totalActiveUsers?: number;

	@serializable(alias('newLogins', primitive()))
	totalLogins?: number;

	@serializable(alias('notLoggenIn', primitive()))
	notLoggenIn?: number;

	@serializable(alias('videoViewed', primitive()))
	videoViewed?: number;

	@serializable(alias('pdfViewed', primitive()))
	pdfViewed?: number;

	@serializable(alias('quickQuiz', primitive()))
	quickQuiz?: number;

	@serializable(alias('excercise', primitive()))
	excercise?: number;
}